import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: 'login',
  },
  {
    path: '/dashboard/:lang?',
    name: 'dashboard',
    component: () => import('@/views/dashboard/Dashboard.vue'),
  },
  {
    path: '/login/:lang?',
    name: 'pages-login',
    component: () => import('@/views/pages/Login.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: "/logout",
    name: "logout",
    component: {
      beforeRouteEnter(to, from, next) {
        localStorage.removeItem("user");
        localStorage.removeItem("token")
        next("/login?fromLogout=yes");
      }
    }
  },
  {
    path: '/register',
    name: 'pages-register',
    component: () => import('@/views/pages/Register.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/forgotten-password',
    name: 'forgotten-password',
    component: () => import('@/views/pages/ForgottenPassword.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/:token/confirm-password',
    name: 'confirm-password',
    component: () => import('@/views/pages/ConfirmPassword.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/change-password',
    name: 'change-password',
    component: () => import('@/views/pages/ChangePassword.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/Error.vue'),
    meta: {
      layout: 'blank',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = to.path.startsWith('/dashboard');
  const loggedIn = localStorage.getItem('user');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  next();
})

export default router
